import { find, split, forEach, last, get, map, startsWith } from 'lodash';
import { formatSortCode } from '../utils/NumberUtils';
import {
  CREDIT_CARD,
  KAPITI_PRODUCT_CODE,
  UNFORMAT_CREDIT_CARD_NUMBER,
  AMOUNT_LIMIT,
} from '../constants/StringConstants';

const extractThirdIndex = 3;
const isAlertsAvailable = (account) => {
  return (
    account.actions_available['/account/alerts'] ||
    account.actions_available['/account/alerts/transaction/debit'] ||
    account.actions_available['/account/alerts/transaction/credit']
  );
};
export const getAccountList = (accountList) => {
  const accounts = [];
  forEach(accountList, (account) => {
    if (isAlertsAvailable(account)) {
      accounts.push(account);
    }
  });
  return accounts;
};
export const getAccountDetails = (id, accountList) => {
  const selectedAccount = find(accountList, { id: id }) || {};
  return selectedAccount;
};
const accountNumberFromAccountDetails = (accountDetails) => split(accountDetails.number, '-');

export const getAccountDisplayNumber = (accountDetails) => {
  if (accountDetails.type === CREDIT_CARD) {
    return {
      accNumber: UNFORMAT_CREDIT_CARD_NUMBER(accountDetails),
    };
  } else if (accountDetails.productCode === KAPITI_PRODUCT_CODE) {
    const [_initial, accNumber] = accountNumberFromAccountDetails(accountDetails);
    return { accNumber };
  }

  const [rawSortCode, accNumber] = accountNumberFromAccountDetails(accountDetails);

  return {
    accNumber,
    sortcode: formatSortCode(rawSortCode),
  };
};

const removeMultipleZeros = (amount) => {
  if (startsWith(amount, '00')) {
    return amount.substring(1);
  }
  return amount;
};

export const stripIllegalCharacters = (amount) => {
  if (!amount) {
    return amount;
  }
  const cleanedAmount = amount.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.');

  const amtParts = split(cleanedAmount, '.');
  if (amtParts.length > 1 && last(amtParts).length > 2) {
    return cleanedAmount.slice(0, -(last(amtParts).length - 2));
  }
  return removeMultipleZeros(cleanedAmount);
};

export const amountWithinLimit = (amount) => {
  const numericAmount = Number.parseFloat(amount);
  return !(!Number.isNaN(numericAmount) && numericAmount > AMOUNT_LIMIT);
};
export const getSelectedAccountDetails = (id, validAccountList) => {
  const selectedAccount = find(validAccountList, { account_id: id }) || {};
  return selectedAccount;
};

export const isAccountCMAElligible = (accountDetails) =>
  accountDetails.actions_available['/account/payments/alerts'];

export const getCustomerNumberInfoText = (alertLandingPageInfo, userPhoneNumber) => {
  const extractMobileContactNumber = find(userPhoneNumber, { type: 'M' });
  if (extractMobileContactNumber && extractMobileContactNumber.phone_number) {
    const contactNumber = extractMobileContactNumber.phone_number.match(/(\d{3})(\d{4})(\d{4})/);
    const hideContactNumber = `${contactNumber[1]}** **${contactNumber[extractThirdIndex]}`;
    return alertLandingPageInfo.replace('{contactNumber}', hideContactNumber);
  }
  return '';
};
export const getDisplayName = (account) => {
  let displayName = account.metadata.display_name;
  if (!displayName) {
    displayName = account.product.name;
  }
  return displayName;
};

export const getSavingAccountsList = (accounts) =>
  map(accounts, (account) => {
    return {
      id: account.id,
      sortCode: getAccountDisplayNumber(account).sortcode,
      accountNumber: getAccountDisplayNumber(account).accNumber,
      number: account.number,
      type: account.type,
      displayName: getDisplayName(account),
      ...getBalances(account.balances),
    };
  });

const formatAmount = (amount) => {
  if (amount !== '') {
    return Number.parseFloat(amount).toLocaleString('en-GB', { minimumFractionDigits: 2 });
  }
  return amount;
};
const getBalances = (balances) => {
  const current = find(balances, { type: 'current' });
  const available = find(balances, { type: 'available' });
  return {
    currentBalance: formatAmount(get(current, 'amount.value', '')),
    availableBalance: formatAmount(get(available, 'amount.value', '')),
  };
};
export const hasSingleAccount = (accountList) => {
  if (accountList.length === 1) {
    return true;
  }
  return false;
};
